import { Injectable } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalsComponent } from '../../../components/modals/modals.component';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {

  private modalRef!: NgbModalRef;

  constructor(
    private modalService: NgbModal, private modalConfig: NgbModalConfig
  ) {
    this.modalConfig.backdrop = 'static';
    this.modalConfig.keyboard = false;
  }

  open(buttonOptions?: ButtonOptions[],  icon: string ="error", showIcon: boolean = false, showXIcon: boolean = true, title?: string, titleMsg?: string, titleStyle?: string, modalSize: ModalSize = 'sm' ) {
    this.modalRef = this.modalService.open(ModalsComponent, { size: modalSize });
    this.modalRef.componentInstance.modalRef = this.modalRef
    this.modalRef.componentInstance.icon = icon
    this.modalRef.componentInstance.showIcon = showIcon
    this.modalRef.componentInstance.showXIcon = showXIcon
    this.modalRef.componentInstance.buttonOptions = buttonOptions
    this.modalRef.componentInstance.title = title
    this.modalRef.componentInstance.titleMsg = titleMsg;
    this.modalRef.componentInstance.titleStyle = titleStyle;
    return this.modalRef;
  }
}

type ButtonOptions = {
  label: string,
  class: string,
  eventName: string
}

type ModalSize = 'sm' | 'md' |'lg' | 'xl';